var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-cascader", {
    staticStyle: { width: "200px" },
    attrs: {
      size: "small",
      options: _vm.frameTreeData,
      props: { checkStrictly: true, value: "id", label: "label" },
      placeholder: "请选择管理范围",
      filterable: "",
      "show-all-levels": false,
    },
    on: { change: _vm.changeFrame },
    model: {
      value: _vm.frame_id,
      callback: function ($$v) {
        _vm.frame_id = $$v
      },
      expression: "frame_id",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }